import { render, staticRenderFns } from "./ProductOptionSelector.vue?vue&type=template&id=34bc988f&"
import script from "./ProductOptionSelector.vue?vue&type=script&lang=js&"
export * from "./ProductOptionSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports